<div class="manual-acceptance-card" [class.alarm]="alarmMode$ | async">
	<!-- Header -->
	<div class="header">
		<div class="timer">
			@if (timeLeft$ | async; as seconds ) {
			<mat-icon>schedule</mat-icon>
			<span>{{ formatTime(seconds) }}</span>
			}
		</div>

		<div class="subtitle">
			{{ 'manual_acceptance.subtitle' | translate:{ minutes: timeWindow } }}
		</div>
	</div>

	<!-- Preparation -->
	<div class="field">
		<label>{{ 'manual_acceptance.preparation_time' | translate }}</label>

		<ng-select
			[(ngModel)]="preparationTime"
			[clearable]="false"
			[searchable]="false"
			class="time-select"
		>
			@for (timeOption of timeOptions; track timeOption) {
			<ng-option [value]="timeOption"
				>{{'time.minutes' | translate: {count: timeOption} }}</ng-option
			>
			}
		</ng-select>
	</div>

	<!-- Delivery -->
	<div class="field">
		<label>{{ 'manual_acceptance.delivery_time' | translate }}</label>

		<ng-select
			[(ngModel)]="deliveryTime"
			[clearable]="false"
			[searchable]="false"
			class="time-select"
		>
			@for (timeOption of timeOptions; track timeOption) {
			<ng-option [value]="timeOption"
				>{{'time.minutes' | translate: {count: timeOption} }}</ng-option
			>
			}
		</ng-select>
	</div>
</div>

<div class="buttons">
	<button class="btn accept" (click)="accept()">
		{{ 'manual_acceptance.accept' | translate }}
	</button>

	<button class="btn reject" (click)="reject()">
		{{ 'manual_acceptance.reject' | translate }}
	</button>
</div>
